import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  islogin:BehaviorSubject<boolean>;
  constructor() { 

    this.islogin = new BehaviorSubject<boolean>(false);
  }


}
